import React, { useRef, useEffect, useState } from 'react';
import styled from 'styled-components';

import { Card } from 'src/components/Cards/Card';
import { Note } from '@annote/types';
import HiddenCards from 'src/components/Cards/HiddenCard';
import { usePanelContext } from 'src/context/PanelContext';
import { CardHandleWrapper } from './Handle';

const CardWrapper = styled.div`
  position: relative;
  height: fit-content;
  width: fit-content;
  /* min-width: 100%; */
  max-width: none;
  /* border: 1px solid green; */
  &:hover {
    z-index: 1001;
  }
`;

export const FlowCard: React.FC<{
  data: {
    note: Note;
    onResize: (id: string, width: number, height: number) => void;
  };
}> = ({ data }) => {
  const { panels } = usePanelContext();
  const nodeRef = useRef<HTMLDivElement>(null);
  const [prevDimensions, setPrevDimensions] = useState({ width: 0, height: 0 });
  const { note, onResize } = data;

  // Make the card readonly if it's being edited in the writer panel
  const isBeingEditedInPanel = note?.type === 'takeaway' && panels.writer.isOpen && panels.writer.activeId === note?.id;

  // console.log('FlowCard: note rerendering', note.id, note.title, note.deletedAt);

  // Observer that calls onResize when the node changes size
  useEffect(() => {
    if (!nodeRef.current || !onResize || !note) return () => {};
    const resizeObserver = new ResizeObserver((entries) => {
      entries.forEach((entry) => {
        const { width, height } = entry.contentRect;
        if (width !== prevDimensions.width || height !== prevDimensions.height) {
          onResize(note.id, width, height);
          setPrevDimensions({ width, height });
        }
      });
    });

    resizeObserver.observe(nodeRef.current);

    return () => {
      resizeObserver.disconnect();
    };
  }, [onResize, note?.id, prevDimensions.width, prevDimensions.height]);

  // Return null AFTER all hooks have been called
  if (!note) return null;

  return (
    <CardWrapper ref={nodeRef} className="card-wrapper">
      <HiddenCards parentNoteId={note.id} kind="backlinks" relationIds={note.backlinks || []} />
      <HiddenCards parentNoteId={note.id} kind="links" relationIds={note.links || []} />
      <CardHandleWrapper noteId={note.id}>
        <Card key={note.id} note={note} readOnly={isBeingEditedInPanel}></Card>
      </CardHandleWrapper>
    </CardWrapper>
  );
};
